export const vh = document.documentElement.clientHeight;
export const vw = document.documentElement.clientWidth;